// 梁
import rlModel from "./rlModel";
import store from "@/store/index";
class rlBeam extends rlModel {
  constructor() {
    super();
    this.componentType = "beam";
    // 顶点数据
    this.points = [];
    // this.Name = null;
    // this.m_sectParamData = {}; //截面源数据
    // this.SectData = []; //截面组合数据
    this.m_gridData = {}; //网格数据
    this.Ecc = null; //梁偏轴距离
    this.HDiff1 = null; //梁顶标高1
    this.HDiff2 = null; //梁顶标高2
    this.Rotation = null; //轴转角

    this.Attribute = 1; //默认为主要构件
    this.classTypeName = "rlBeamSeg"; // 梁类型
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    // this.defaultColor = "#00b4b4"; //默认颜色
    this.Color = "#00FFE5";
    // (this.rlLayer && this.rlLayer[0] && this.rlLayer[0].storey) || "#00b4b4"; //构件颜色
    this.ModelType = "梁";
    //this.Layer = "rlBeamSeg"; //图层名称
    this.LinkGuids = null; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlBeamGroup"; //组名
    // wasm接口方法
    this.getPKPM_BeamData =
      store.state.globalData.rl_wasm_module.getPKPM_BeamData;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);
    this.m_gridData = obj.m_gridData;
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.Rotation = obj.Rotation;

    this.Color = obj.Color ? obj.Color : "#00b4b4";
    // this.Layer = obj.Layer ? obj.Layer : "rlBeamSeg";
    this.LinkGuids = obj.LinkGuids;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.Rotation = obj.Rotation;
  }

  // 添加
  add(obj) {
    const beamParams = obj.beamParams;
    this.ID = obj.ID;
    this.Name = obj.Name;
    this.rlFloorData = obj.rlFloorData;
    this.m_sectParamData = obj.m_sectParamData;
    this.m_gridData = obj.m_gridData;
    this.Guid = obj.Guid;
    this.Ecc = beamParams.Ecc;
    this.HDiff1 = beamParams.HDiff1;
    this.HDiff2 = beamParams.HDiff2;
    this.LevelB = beamParams.LevelB;
    this.Height = Number(beamParams.Height);
    this.ModelNo = obj.ModelNo;

    this.Color = beamParams.Color ? beamParams.Color : "#00b4b4";
    this.Layer = beamParams.Layer ? beamParams.Layer : "rlBeamSeg";
    this.Strength = obj.Strength ? obj.Strength : null;
    this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
  }

  // 数据转换
  convert() {
    let res = this.getPKPM_BeamData(
      this.m_sectParamData.Kind,
      this.m_sectParamData.ShapeVal,
      this.m_gridData.m_stJoint.m_pt[0],
      this.m_gridData.m_stJoint.m_pt[1],
      this.m_gridData.m_edJoint.m_pt[0],
      this.m_gridData.m_edJoint.m_pt[1],
      this.LevelB,
      this.Height,
      this.Ecc,
      this.HDiff1,
      this.HDiff2,
      this.Rotation
    );

    this.getModelDrawData(JSON.parse(res));
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
    }
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    this.points = modelData.Points;
    this.index3dData = modelData["3D"]["3dFaces"]
      .map((item) => item.index)
      .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
  }

  // 克隆方法
  myClone() {
    let newObj = super.myClone();

    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.Rotation = this.Rotation;

    newObj.points = this.points;
    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    // let wObj;
    this.convert();
    if (pWorldDraw.mxObj._is2d) {
      // wObj = this.create2dModel(this.index2dData);
      // wObj.material.color.set(this.Color);
      pWorldDraw.setColor(new THREE.Color(this.Color));
      this.create2dModel(this.index2dData, pWorldDraw);
    }

    this._threeObj = this.create3dModel(
      this.points,
      this.index3dData,
      0.001,
      7
    );

    this.m_gridData.m_beamId = this.objectId();
    // pWorldDraw.drawEntity(wObj);
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["Rotation"] = this.Rotation;
    data["LinkGuids"] = this.LinkGuids;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.objectId();
    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["Rotation"] = this.Rotation;

    return data;
  }

  // 删除
  erase() {
    this.m_gridData ? (this.m_gridData.m_beamId = null) : "";
    super.erase();
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    this.onDwgIn(obj);
    return true;
  }
}

export { rlBeam };
